namespace C2S {

    @C2S.Decorators.registerInterface()
    export class ISetEditValue {
    }

    export interface ISetEditValue {
        setEditValue(source: any, property: PropertyItem): void;
    }
}